'use client'
import {SessionProvider} from 'next-auth/react'
import React from 'react'
import {HeroUIProvider, ToastProvider} from '@heroui/react'
import {Session} from 'next-auth'

const ProviderWrapper = ({
  children,
  session,
}: {
  children: React.ReactNode
  session: Session | null
}) => {
  return (
    <HeroUIProvider locale="tr">
      <SessionProvider
        session={session}
        refetchInterval={1000 * 60}
        refetchOnWindowFocus={false}
        refetchWhenOffline={false}>
        <ToastProvider
          placement="top-right"
          toastProps={{classNames: {base: 'min-w-64'}}}
        />
        {children}
      </SessionProvider>
    </HeroUIProvider>
  )
}

export default ProviderWrapper
